// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_auto_creation_rule_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { TimeOfDay } from "../../google/type/timeofday_pb";
import { file_google_type_timeofday } from "../../google/type/timeofday_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_auto_creation_rule_model.proto.
 */
export const file_bffuser_v1_workflow_auto_creation_rule_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_google_protobuf_timestamp, file_google_type_timeofday]);

/**
 * WorkflowAutoCreationScheduleTrigger holds the inputs of a 定期 (scheduled)
 * rule. The target-date cadence is derived from the template's section and
 * is not stored on the rule.
 *
 * @generated from message bffuser.v1.WorkflowAutoCreationScheduleTrigger
 */
export type WorkflowAutoCreationScheduleTrigger = Message<"bffuser.v1.WorkflowAutoCreationScheduleTrigger"> & {
  /**
   * 起票リード. Non-negative; 0 means the target date itself.
   *
   * @generated from field: int32 lead_value = 1;
   */
  leadValue: number;

  /**
   * @generated from field: bffuser.v1.WorkflowAutoCreationLeadUnit lead_unit = 2;
   */
  leadUnit: WorkflowAutoCreationLeadUnit;

  /**
   * 起票時刻 in JST, minute precision (seconds and nanos are 0).
   *
   * @generated from field: google.type.TimeOfDay fire_time = 3;
   */
  fireTime?: TimeOfDay;

  /**
   * @generated from field: bffuser.v1.WorkflowAutoCreationDayFilter day_filter = 4;
   */
  dayFilter: WorkflowAutoCreationDayFilter;

  /**
   * 計画の自動化 (the stored value; see
   * ListWorkflowAutoCreationRulesResponse.plan_automation_unused_rule_ids).
   *
   * @generated from field: bffuser.v1.WorkflowPlanAutomation plan_automation = 5;
   */
  planAutomation: WorkflowPlanAutomation;
};

/**
 * Describes the message bffuser.v1.WorkflowAutoCreationScheduleTrigger.
 * Use `create(WorkflowAutoCreationScheduleTriggerSchema)` to create a new message.
 */
export const WorkflowAutoCreationScheduleTriggerSchema: GenMessage<WorkflowAutoCreationScheduleTrigger> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_model, 0);

/**
 * WorkflowAutoCreationRule is a 自動起票ルール that creates workflows
 * automatically: one scheduled rule per template × area × lead (lead_value,
 * lead_unit).
 *
 * @generated from message bffuser.v1.WorkflowAutoCreationRule
 */
export type WorkflowAutoCreationRule = Message<"bffuser.v1.WorkflowAutoCreationRule"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workflow_template_id = 2;
   */
  workflowTemplateId: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * 起票の合図. Only 定期 (schedule) exists until event-triggered creation
   * (AC-WFT-024) is provided.
   *
   * @generated from oneof bffuser.v1.WorkflowAutoCreationRule.trigger
   */
  trigger: {
    /**
     * @generated from field: bffuser.v1.WorkflowAutoCreationScheduleTrigger schedule = 10;
     */
    value: WorkflowAutoCreationScheduleTrigger;
    case: "schedule";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 21;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 23;
   */
  updatedAt?: Timestamp;

  /**
   * Why the rule has not created a round whose target date has not ended
   * (spec AC-WFT-050). UNSPECIFIED means there is nothing to tell (and always
   * while the workflow-automation feature is off). Mirrors
   * internalapi.v1.WorkflowAutoCreationRule.notice.
   *
   * @generated from field: bffuser.v1.WorkflowAutoCreationRuleNotice notice = 24;
   */
  notice: WorkflowAutoCreationRuleNotice;
};

/**
 * Describes the message bffuser.v1.WorkflowAutoCreationRule.
 * Use `create(WorkflowAutoCreationRuleSchema)` to create a new message.
 */
export const WorkflowAutoCreationRuleSchema: GenMessage<WorkflowAutoCreationRule> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_auto_creation_rule_model, 1);

/**
 * WorkflowAutoCreationLeadUnit is the unit of the 起票リード (how many days /
 * months / years before the target date a workflow is created).
 *
 * @generated from enum bffuser.v1.WorkflowAutoCreationLeadUnit
 */
export enum WorkflowAutoCreationLeadUnit {
  /**
   * @generated from enum value: WORKFLOW_AUTO_CREATION_LEAD_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 日
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_LEAD_UNIT_DAY = 1;
   */
  DAY = 1,

  /**
   * 月
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_LEAD_UNIT_MONTH = 2;
   */
  MONTH = 2,

  /**
   * 年
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_LEAD_UNIT_YEAR = 3;
   */
  YEAR = 3,
}

/**
 * Describes the enum bffuser.v1.WorkflowAutoCreationLeadUnit.
 */
export const WorkflowAutoCreationLeadUnitSchema: GenEnum<WorkflowAutoCreationLeadUnit> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_auto_creation_rule_model, 0);

/**
 * WorkflowAutoCreationDayFilter is the 曜日フィルター of a scheduled rule.
 *
 * @generated from enum bffuser.v1.WorkflowAutoCreationDayFilter
 */
export enum WorkflowAutoCreationDayFilter {
  /**
   * @generated from enum value: WORKFLOW_AUTO_CREATION_DAY_FILTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 毎日
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_DAY_FILTER_EVERY_DAY = 1;
   */
  EVERY_DAY = 1,

  /**
   * 平日のみ
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_DAY_FILTER_WEEKDAYS = 2;
   */
  WEEKDAYS = 2,

  /**
   * 平日祝日除く
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_DAY_FILTER_WEEKDAYS_EXCLUDING_HOLIDAYS = 3;
   */
  WEEKDAYS_EXCLUDING_HOLIDAYS = 3,
}

/**
 * Describes the enum bffuser.v1.WorkflowAutoCreationDayFilter.
 */
export const WorkflowAutoCreationDayFilterSchema: GenEnum<WorkflowAutoCreationDayFilter> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_auto_creation_rule_model, 1);

/**
 * WorkflowPlanAutomation is the 計画の自動化 of a scheduled rule: whether the
 * 需要調達計画 / 発電販売計画 sub-steps of the workflows it creates keep the
 * template's approval setting or are overridden. Not applied while the
 * template has an approval-required target sub-step.
 *
 * @generated from enum bffuser.v1.WorkflowPlanAutomation
 */
export enum WorkflowPlanAutomation {
  /**
   * @generated from enum value: WORKFLOW_PLAN_AUTOMATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 雛形どおり
   *
   * @generated from enum value: WORKFLOW_PLAN_AUTOMATION_SAME_AS_TEMPLATE = 1;
   */
  SAME_AS_TEMPLATE = 1,

  /**
   * 自動提出 (approval mode 自動)
   *
   * @generated from enum value: WORKFLOW_PLAN_AUTOMATION_AUTO_SUBMIT = 2;
   */
  AUTO_SUBMIT = 2,

  /**
   * 自動作成のみ (approval mode 承認なし)
   *
   * @generated from enum value: WORKFLOW_PLAN_AUTOMATION_CREATE_ONLY = 3;
   */
  CREATE_ONLY = 3,
}

/**
 * Describes the enum bffuser.v1.WorkflowPlanAutomation.
 */
export const WorkflowPlanAutomationSchema: GenEnum<WorkflowPlanAutomation> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_auto_creation_rule_model, 2);

/**
 * WorkflowAutoCreationRuleNotice is the notice of a 定期 rule on the rule list
 * (spec AC-WFT-050 / AC-WFT-057). Mirrors internalapi.v1.WorkflowAutoCreationRuleNotice.
 *
 * @generated from enum bffuser.v1.WorkflowAutoCreationRuleNotice
 */
export enum WorkflowAutoCreationRuleNotice {
  /**
   * No notice.
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_RULE_NOTICE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * BG が無いため起票していません
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_RULE_NOTICE_BG_MISSING = 1;
   */
  BG_MISSING = 1,

  /**
   * 同じ種類の BG が複数あるため起票していません
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_RULE_NOTICE_BG_DUPLICATED = 2;
   */
  BG_DUPLICATED = 2,

  /**
   * 手動で作成した未完了のワークフローがあるため起票していません (AC-WFT-057)
   *
   * @generated from enum value: WORKFLOW_AUTO_CREATION_RULE_NOTICE_MANUAL_OPEN = 3;
   */
  MANUAL_OPEN = 3,
}

/**
 * Describes the enum bffuser.v1.WorkflowAutoCreationRuleNotice.
 */
export const WorkflowAutoCreationRuleNoticeSchema: GenEnum<WorkflowAutoCreationRuleNotice> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_auto_creation_rule_model, 3);

